module.exports = __webpack_public_path__ + "img/GasbotSideTopDiscordLogos.f7dbcd49.webp";